module.exports = __webpack_public_path__ + "img/搜索.ba45e86c.png";